export const LOGIN_STEPPER_NAMESPACE = 'login';

export enum LOGIN_STEPS {
  LOGIN = 'login',
  COMPANY_SELECTION = 'company-selection',
}
